import React, { useContext, useEffect, useRef } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { IStyleContext, StyleContext } from '../../styleState/styleContext';
import JSONUploader from 'components/UploaderAndDownloader/JSONUploader';
import BlobDownloader from 'components/UploaderAndDownloader/BlobDownloader';
import { createAppError } from 'utils/helpers';
import { postMediaFile } from 'backend/additionalInformation';
import style from './AdditionalSettings.module.scss';

const AdditionalSettings: React.FC = () => {
	const { addAppError } = useContext<IAppContext>(AppContext);
	const { setFileIdForAdditionalSetting, selectedGroup, additionalSetting } = useContext<IStyleContext>(StyleContext);
	const headingElement = useRef<null | HTMLDivElement>(null);
	// const [isValidJson, setIsValidJson] = useState<boolean>(true);

	useEffect(() => {
		if (selectedGroup?.id === 'additionalSettingFileID') {
			headingElement.current?.scrollIntoView({ behavior: 'smooth' });
		}
	}, [selectedGroup]);

	const handleFileLoad = async (jsonString: string, fullFile: null | File) => {
		// setIsValidJson(true);
		try {
			// const parsedSettings = JSON.parse(jsonString);
			// const requiredProperties = [
			// 	'admin',
			// 	'api',
			// 	'game',
			// 	'how_it_works_state',
			// 	'is_show_waiter',
			// 	'led_colors',
			// 	'saver_state',
			// 	'service_charge',
			// 	'system',
			// ];
			// if (!requiredProperties.every((el) => el in parsedSettings)) {
			// 	setIsValidJson(false);
			// 	setFileIdForAdditionalSetting('');
			// 	return;
			// }
			if (fullFile) {
				const formData = new FormData();
				formData.append('file', fullFile, fullFile.name);
				const response = await postMediaFile({ data: formData });
				setFileIdForAdditionalSetting(response.data.fileId);
			}
		} catch (err) {
			const error = err as Error;
			const appError = createAppError(error);
			addAppError(appError);
		}
	};

	return (
		<div className={style.container} ref={headingElement} data-test="AdditionalSettings">
			<JSONUploader
				onFileLoad={handleFileLoad}
				id="additionalSettingsFile"
				label="uploadSettings"
				// isValidJson={isValidJson}
			/>
			<div className={style.downloadBnt}>
				<BlobDownloader
					filePath={additionalSetting.filePath}
					fileExtension="json"
					fileName="additional_settings"
					label="downloadSettings"
				/>
			</div>
		</div>
	);
};

export default React.memo(AdditionalSettings);
